<script lang="ts">
    import { Button, Col, Form, Input, Modal, ModalBody, ModalHeader, Row } from "sveltestrap";
    import { AddCategory, Cancel, Save } from "../../../utils/Constant/Constant";
    let open:boolean = false;
    const toggle = () => (open = !open);
</script>
<li>
  <Button class="btn-category" on:click={toggle}>
      <span class="title"> + {AddCategory}</span>
  </Button>
  <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
    <Modal class="modal-dialog" isOpen={open} {toggle}>
      <div class="modal-content">
        <ModalHeader {toggle}>{AddCategory}</ModalHeader>
        <ModalBody>
          <Form class="form-bookmark">
            <Row class="g-2">
              <Col md="12" class="mb-3" >
                <Input type="text" required placeholder="Enter category name" autocomplete="off" />
              </Col>
            </Row>
            <Button color="secondary" on:click={toggle}>{Save}</Button>
            <Button color="primary" on:click={toggle}>{Cancel}</Button>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  </div>
</li>